let configPromise: Promise<{ turnstileSiteKey: string; appUrl: string }> | null = null;

export async function fetchClientConfig() {
  if (!configPromise) {
    configPromise = fetch("/api/config", { credentials: "include" })
      .then((res) => res.json())
      .catch((error) => {
        console.error("Failed to load client config", error);
        return { turnstileSiteKey: "", appUrl: "" };
      });
  }
  return configPromise;
}
